// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionHeading__title__2LZbc"};